<template>
  <div>
    <el-collapse v-model="activeNames" style="width: 100%">
      <controlWidthAndSizeAndZindex v-show="activeType == 1" :options="options" :ids="ids" />
      <el-collapse-item
        v-show="activeType == 1"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
        title="外观"
        name="3"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')">
          <div class="content">
            <div>
              <slider-and-input
                inputWidth="small"
                inputHeight="small"
                :value.sync="indent"
                title="缩进"
                :sliderMax="50"
                suffix="px"
              />
            </div>
            <div class="verticallyCenter mt16">
              <slider-and-input
                inputWidth="small"
                inputHeight="small"
                :value.sync="opacity"
                title="透明度"
                :sliderMax="100"
                suffix="%"
              />
            </div>
            <cx-background :background.sync="background" imgType="10" class="mt16" />
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('b')"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-show="activeType == 1"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
        title="边框"
        name="4"
      >
        <div class="setting-item" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')">
          <div class="content">
            <div class="content-item mb16">
              <border-radius
                :borderTypeFlag.sync="borderTypeFlag"
                :borderRadius.sync="borderRadius"
                :borderTopLeftRadius.sync="borderTopLeftRadius"
                :borderTopRightRadius.sync="borderTopRightRadius"
                :borderBottomRightRadius.sync="borderBottomRightRadius"
                :borderBottomLeftRadius.sync="borderBottomLeftRadius"
              />
            </div>
            <div class="content-item mb24 clearFloat">
              <div class="checkbox_colorPicker_container mb16">
                <span class="fs14">边框</span>
              </div>
              <cx-border
                :borderWidth.sync="borderWidth"
                :borderStyle.sync="borderStyle"
                :borderColor.sync="borderColor"
                :borderIsThemeColor.sync="borderIsThemeColor"
              />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-show="activeType == 1"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
        title="图标样式"
        name="7"
      >
        <div class="content-item" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')">
          <img-icon-upload class="mb16" :imgSrc.sync="iconSrc" :iconType.sync="iconType" :iconColor.sync="iconColor" />
          <div v-show="iconSrc.length" class="content-item mb16 verticallyCenter">
            <span class="mr16 fs14">位置</span>
            <el-radio-group v-model="iconPosition">
              <el-radio label="left">左</el-radio>
              <el-radio label="right">右</el-radio>
            </el-radio-group>
          </div>
          <div class="verticallyCenter mb16" v-if="iconType === 'icon'">
            <span class="mr16 fs14">颜色</span>
            <color-picker-theme-color
              class="flex1"
              :isThemeColor.sync="iconColorIsThemeColor"
              :color.sync="iconColor"
            />
          </div>

          <slider-and-input class="mb16" :value.sync="iconWidth" title="大小" :sliderMax="navWidth" suffix="px" />
          <slider-and-input :value.sync="iconMargin" title="间距" :sliderMax="navWidth" suffix="px" />
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="activeType == 1"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
        title="一级菜单"
        name="1"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
          <div>
            <slider-and-input
              class="mb16"
              v-if="request_prefix === 'bigScreen'"
              :value.sync="topNavMarginBottom"
              title="间距"
              :sliderMax="200"
              suffix="px"
            />
            <el-radio-group v-model="widthAuto">
              <el-radio :label="true">自适应</el-radio>
              <el-radio :label="false">固定宽度</el-radio>
            </el-radio-group>
            <slider-and-input
              class="mt16"
              v-if="!widthAuto"
              inputWidth="small"
              inputHeight="small"
              :value.sync="navWidth"
              title=""
              titlePosition="singleLine"
              :sliderMax="500"
              suffix="px"
            />
          </div>
        </div>
        <text-setting-complex-update
          class="mt16"
          :fontFamily.sync="fontFamily"
          :fontSize.sync="fontSize"
          :fontWeight.sync="fontWeight"
          :fontStyle.sync="fontStyle"
          :textDecoration.sync="textDecoration"
          :lineHeight.sync="lineHeight"
          :lineHeightType.sync="lineHeightType"
          :letterSpacing.sync="letterSpacing"
          :activeArrangement.sync="activeArrangement"
          :writingMode.sync="writingMode"
          :textAlign.sync="textAlign"
          :activeArrangementOrder.sync="activeArrangementOrder"
          :isThemeColor.sync="textIsThemeColor"
          :colorArr.sync="colorArr"
          :activeNameColor="activeNameColor"
          :activeName.sync="activeNameColor"
          :showSecondTab="true"
          :showOverflowSetting="true"
          :contentHasLimit.sync="topNavTextLimit"
          :contentHasLimitRadio="'字数'"
          :overflowTypes="['字数', '无']"
          :textLimitWords.sync="topNavTextLimitCount"
          :options="options"
        />
        <!--          <div class="mt16 verticallyCenter">-->
        <!--            <div class="mr16">排列方向:</div>-->
        <!--            <el-radio-group v-model="directionMode">-->
        <!--              <el-radio label="horizontal">水平</el-radio>-->
        <!--              <el-radio label="vertical">垂直</el-radio>-->
        <!--            </el-radio-group>-->
        <!--          </div>-->
        <div class="mt16" v-if="directionMode === 'vertical'">
          <el-checkbox v-model="collapse">折叠收起菜单</el-checkbox>
        </div>
        <border-radius
          class="mt16"
          :borderTypeFlag.sync="topNavBorderTypeFlag"
          :borderRadius.sync="topNavBorderRadius"
          :borderTopLeftRadius.sync="topNavBorderTopLeftRadius"
          :borderTopRightRadius.sync="topNavBorderTopRightRadius"
          :borderBottomRightRadius.sync="topNavBorderBottomRightRadius"
          :borderBottomLeftRadius.sync="topNavBorderBottomLeftRadius"
        />
        <div class="mt16">
          <span>边框</span>
          <cx-border
            :borderWidth.sync="topNavBorderWidth"
            :borderStyle.sync="topNavBorderStyle"
            :borderColor.sync="topNavBorderColor"
            :borderIsThemeColor.sync="topNavBorderIsThemeColor"
          />
        </div>
        <div class="mt8">
          <el-checkbox v-model="clearLastBorder">清除最后一个选项的下边框</el-checkbox>
          <!--          <div class="mt16">-->
          <!--            <cx-padding-->
          <!--              :paddingTypeFlag.sync="topNavPaddingTypeFlag"-->
          <!--              :padding.sync="topNavPadding"-->
          <!--              :paddingTop.sync="topNavPaddingTop"-->
          <!--              :paddingRight.sync="topNavPaddingRight"-->
          <!--              :paddingBottom.sync="topNavPaddingBottom"-->
          <!--              :paddingLeft.sync="topNavPaddingLeft"-->
          <!--            />-->
          <!--          </div>-->
          <div class="mt16">
            <cx-background :background.sync="topNavBackground" imgType="10" />
          </div>
          <div class="mt16">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('topNavB')"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="topNavBoxShadowH"
              :boxShadowV.sync="topNavBoxShadowV"
              :boxShadowBlur.sync="topNavBoxShadowBlur"
              :boxShadowSpread.sync="topNavBoxShadowSpread"
              :boxShadowColor.sync="topNavBoxShadowColor"
            ></box-shadow>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="activeType == 1"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
        title="次级菜单"
        name="2"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
          <div class="verticallyCenter mb16" v-if="request_prefix === 'stage' ">
            <span class="mr16">触发方式:</span>
            <el-radio-group v-model="menuTrigger">
              <el-radio label="hover">悬浮</el-radio>
              <el-radio label="click">点击</el-radio>
            </el-radio-group>
          </div>
          <slider-and-input
            class="mb16"
            v-if="request_prefix === 'bigScreen'"
            :value.sync="liMarginBottom"
            title="间距"
            :sliderMax="200"
            suffix="px"
          />
          <div class="mb16" v-if="request_prefix === 'bigScreen'">
            <span>间距背景颜色</span>
            <color-picker-theme-color class="flex1 mt8" :isThemeColor.sync="liBgIsThemeColor" :color.sync="liBgColor" />
          </div>
          <div class="verticallyCenter mb16">
            <el-checkbox class="" v-model="liIsSameSize">尺寸自动</el-checkbox>
            <i class="tips-btn icon-portal-info2" @click="explainDialogClick()"></i>
          </div>
          <slider-and-input
            class="mb16"
            v-if="!liIsSameSize"
            :value.sync="liWidth"
            title="列表宽度"
            :sliderMax="500"
            suffix="px"
          />
          <slider-and-input v-if="!liIsSameSize" :value.sync="liHeight" title="单行高度" :sliderMax="500" suffix="px" />
          <border-radius
            class="mt16"
            :borderTypeFlag.sync="topNavBorderTypeFlag1"
            :borderRadius.sync="topNavBorderRadius1"
            :borderTopLeftRadius.sync="topNavBorderTopLeftRadius1"
            :borderTopRightRadius.sync="topNavBorderTopRightRadius1"
            :borderBottomRightRadius.sync="topNavBorderBottomRightRadius1"
            :borderBottomLeftRadius.sync="topNavBorderBottomLeftRadius1"
          />
          <div class="mt16">
            <span>边框</span>
            <cx-border
              :borderWidth.sync="liBorderWidth"
              :borderStyle.sync="liBorderStyle"
              :borderColor.sync="liBorderColor"
              :borderIsThemeColor.sync="liBorderIsThemeColor"
            />
          </div>
          <div class="mt16">
            <el-checkbox v-model="clearLiLastBorder">清除最后一个选项的下边框</el-checkbox>
          </div>
          <div class="mt16">
            <span class="mb8 inlineMiddle">文字样式</span>
            <text-setting-complex-update
              class="mt16"
              :fontFamily.sync="liFontFamily"
              :fontSize.sync="liFontSize"
              :fontWeight.sync="liFontWeight"
              :fontStyle.sync="liFontStyle"
              :textDecoration.sync="liTextDecoration"
              :lineHeight.sync="liLineHeight"
              :lineHeightType.sync="liLineHeightType"
              :letterSpacing.sync="liLetterSpacing"
              :activeArrangement.sync="liActiveArrangement"
              :writingMode.sync="liWritingMode"
              :textAlign.sync="liTextAlign"
              :activeArrangementOrder.sync="liActiveArrangementOrder"
              :isThemeColor.sync="liIsThemeColor"
              :colorArr.sync="liFontColorArr"
              :activeName.sync="liFontActiveNameColor"
              :activeNameColor="liFontActiveNameColor"
              :showOverflowSetting="true"
              :contentHasLimit.sync="topNavTextLimit1"
              :contentHasLimitRadio="'字数'"
              :overflowTypes="['字数', '无']"
              :textLimitWords.sync="topNavTextLimitCount1"
              :options="options"
            />
          </div>
          <div class="content-item mt16">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('selectB')"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="selectBoxShadowH"
              :boxShadowV.sync="selectBoxShadowV"
              :boxShadowBlur.sync="selectBoxShadowBlur"
              :boxShadowSpread.sync="selectBoxShadowSpread"
              :boxShadowColor.sync="selectBoxShadowColor"
            ></box-shadow>

            <div class="mt16">
              <cx-background :background.sync="topNavBackground1" imgType="10" />
            </div>
            <div class="mt16" style="display: none">
              <span>背景</span>
              <color-picker-theme-color
                class="flex1 mt8"
                :isThemeColor.sync="ulBgIsThemeColor"
                :color.sync="ulBgColor"
              />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="activeType == 2"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
        title="一级菜单"
        name="5"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')">
          <text-setting-complex-update
            :fontFamily.sync="activeFontFamily"
            :fontSize.sync="activeFontSize"
            :fontWeight.sync="activeFontWeight"
            :fontStyle.sync="activeFontStyle"
            :textDecoration.sync="activeTextDecoration"
            :lineHeight.sync="activeLineHeight"
            :lineHeightType.sync="activeLineHeightType"
            :letterSpacing.sync="activeLetterSpacing"
            :activeArrangement.sync="activeActiveArrangement"
            :writingMode.sync="activeWritingMode"
            :textAlign.sync="activeTextAlign"
            :activeArrangementOrder.sync="activeArrangementOrder"
            :isThemeColor.sync="activeTextIsThemeColor"
            :colorArr.sync="activeFontColorArr"
            :activeName.sync="activeActiveNameColor"
            :activeNameColor="activeActiveNameColor"
            :options="options"
          />
          <div class="mt16">
            <span>边框</span>
            <cx-border
              :borderWidth.sync="activeBorderWidth"
              :borderStyle.sync="activeBorderStyle"
              :borderColor.sync="activeBorderColor"
              :borderIsThemeColor.sync="activeBorderIsThemeColor"
            />
          </div>
          <!--          <div class="mt16">-->
          <!--            <el-checkbox v-model="clearActiveLastBorder">清除最后一个选项的下边框</el-checkbox>-->
          <!--          </div>-->
          <div class="mt16">
            <!--            <span>背景</span>-->
            <!--            <color-picker-theme-color-->
            <!--              class="flex1 mt8"-->
            <!--              :isThemeColor.sync="activeBgIsThemeColor"-->
            <!--              :color.sync="activeBgColor"-->
            <!--            />-->
            <cx-background :background.sync="activeBgColor" imgType="10" />
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-show="activeType == 2"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '9')"
        title="次级菜单"
        name="9"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '9')">
          <text-setting-complex-update
            :fontFamily.sync="liActiveFontFamily"
            :fontSize.sync="liActiveFontSize"
            :fontWeight.sync="liActiveFontWeight"
            :fontStyle.sync="liActiveFontStyle"
            :textDecoration.sync="liActiveTextDecoration"
            :lineHeight.sync="liActiveLineHeight"
            :lineHeightType.sync="liActiveLineHeightType"
            :letterSpacing.sync="liActiveLetterSpacing"
            :activeArrangement.sync="liActiveActiveArrangement"
            :writingMode.sync="liActiveWritingMode"
            :textAlign.sync="liActiveTextAlign"
            :activeArrangementOrder.sync="liActiveActiveArrangementOrder"
            :isThemeColor.sync="liActiveTextIsThemeColor"
            :colorArr.sync="liActiveFontColorArr"
            :activeName.sync="liActiveActiveNameColor"
            :activeNameColor.sync="liActiveActiveNameColor"
            :options="options"
          />
          <div class="mt16">
            <span>边框</span>
            <cx-border
              :borderWidth.sync="liActiveBorderWidth"
              :borderStyle.sync="liActiveBorderStyle"
              :borderColor.sync="liActiveBorderColor"
              :borderIsThemeColor.sync="liActiveBorderIsThemeColor"
            />
          </div>
          <!--          <div class="mt16">-->
          <!--            <el-checkbox v-model="clearLiActiveLastBorder">清除最后一个选项的下边框</el-checkbox>-->
          <!--          </div>-->
          <div class="mt16">
            <!--            <span>背景</span>-->
            <cx-background :background.sync="liActiveBgColor" imgType="10" />
            <!--            <color-picker-theme-color-->
            <!--              class="flex1 mt8"-->
            <!--              :isThemeColor.sync="liActiveBgIsThemeColor"-->
            <!--              :color.sync="liActiveBgColor"-->
            <!--            />-->
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="activeType == 3"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
        title="一级菜单"
        name="6"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '6')">
          <el-checkbox v-model="hoverIsSameActive">同选中状态</el-checkbox>
          <div class="mt16" v-if="!hoverIsSameActive">
            <text-setting-complex-update
              :fontFamily.sync="hoverFontFamily"
              :fontSize.sync="hoverFontSize"
              :fontWeight.sync="hoverFontWeight"
              :fontStyle.sync="hoverFontStyle"
              :textDecoration.sync="hoverTextDecoration"
              :lineHeight.sync="hoverLineHeight"
              :lineHeightType.sync="hoverLineHeightType"
              :letterSpacing.sync="hoverLetterSpacing"
              :activeArrangement.sync="hoverActiveArrangement"
              :writingMode.sync="hoverWritingMode"
              :textAlign.sync="hoverTextAlign"
              :activeArrangementOrder.sync="hoverActiveArrangementOrder"
              :isThemeColor.sync="hoverTextIsThemeColor"
              :colorArr.sync="hoverFontColorArr"
              :activeName.sync="hoverActiveNameColor"
              :activeNameColor="hoverActiveNameColor"
              :options="options"
            />
            <div class="mt16">
              <span>边框</span>
              <cx-border
                :borderWidth.sync="hoverBorderWidth"
                :borderStyle.sync="hoverBorderStyle"
                :borderColor.sync="hoverBorderColor"
                :borderIsThemeColor.sync="hoverBorderIsThemeColor"
              />
            </div>
            <div class="mt16">
              <cx-background :background.sync="hoverBgColor" imgType="10" />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="activeType == 3"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
        title="次级菜单"
        name="8"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '8')">
          <el-checkbox v-model="liHoverIsSameActive">同选中状态</el-checkbox>
          <div class="mt16" v-if="!liHoverIsSameActive">
            <text-setting-complex-update
              :fontFamily.sync="liHoverFontFamily"
              :fontSize.sync="liHoverFontSize"
              :fontWeight.sync="liHoverFontWeight"
              :fontStyle.sync="liHoverFontStyle"
              :textDecoration.sync="liHoverTextDecoration"
              :lineHeight.sync="liHoverLineHeight"
              :lineHeightType.sync="liHoverLineHeightType"
              :letterSpacing.sync="liHoverLetterSpacing"
              :activeArrangement.sync="liHoverActiveArrangement"
              :writingMode.sync="liHoverWritingMode"
              :textAlign.sync="liHoverTextAlign"
              :activeArrangementOrder.sync="liHoverActiveArrangementOrder"
              :isThemeColor.sync="liHoverTextIsThemeColor"
              :colorArr.sync="liHoverFontColorArr"
              :activeName.sync="liHoverActiveNameColor"
              :activeNameColor.sync="liHoverActiveNameColor"
              :options="options"
            />
            <div class="mt16">
              <span>边框</span>
              <cx-border
                :borderWidth.sync="liHoverBorderWidth"
                :borderStyle.sync="liHoverBorderStyle"
                :borderColor.sync="liHoverBorderColor"
                :borderIsThemeColor.sync="liHoverBorderIsThemeColor"
              />
            </div>
            <!--          <div class="mt16">-->
            <!--            <el-checkbox v-model="clearLiHoverLastBorder">清除最后一个选项的下边框</el-checkbox>-->
            <!--          </div>-->
            <div class="mt16">
              <cx-background :background.sync="liHoverBgColor" imgType="10" />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-show="$store.state.states.showPluginSetting"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '9')"
        title="插件"
        name="10"
      >
        <div class="setting-item" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '9')">
          <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ explainTitle }}：</span>{{ explainTips }}
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import rowColLayoutSize from "publicSetting/rowColLayoutSize"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  components: {
    controlWidthAndSizeAndZindex,
    elementPluginSetting,
    rowColLayoutSize
  },
  props: {
    statusOpened: Boolean,
    options: Object,
    activeType: String
  },
  data() {
    return {
      activeNames: ["0", "1"],
      collapseActiveNames: ["1", "2"],
      allCollapseNames: ["2", "3", "4", "5", "6", "7", "8"],
      this1: this,
      explainDialog: false,
      explainTitle: "",
      explainTips: "",
      explainImgSrc: "",
      explainVideoSrc: ""
    }
  },
  mounted() {
    this.$emit("update:statusOpened", true)
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
    
  },
  methods: {
    resetSelectBorder(val) {
      this.liBorderRadius = val
      this.liBorderTopLeftRadius = val
      this.liBorderTopRightRadius = val
      this.liBorderBottomRightRadius = val
      this.liBorderBottomLeftRadius = val
    },
    changeBorderRadiusType(value, hoverFlag) {
      let propName = hoverFlag ? hoverFlag + "BorderTypeFlag" : "borderTypeFlag"
      if (this[propName] === value) {
        return
      }
      this[propName] = value
      // 暂时只处理默认情况  悬浮情况后面有可能会有改动
      this.borderTopRightRadius = this.borderTopLeftRadius
      this.borderBottomLeftRadius = this.borderTopLeftRadius
      this.borderBottomRightRadius = this.borderTopLeftRadius
    },
    addBoxshadow(prefix) {
      console.log("prefix", prefix)
      if (!Array.isArray(this[`${prefix}oxShadowH`])) {
        this[`${prefix}oxShadowH`] = [this[`${prefix}oxShadowH`]]
        this[`${prefix}oxShadowV`] = [this[`${prefix}oxShadowV`]]
        this[`${prefix}oxShadowBlur`] = [this[`${prefix}oxShadowBlur`]]
        this[`${prefix}oxShadowSpread`] = [this[`${prefix}oxShadowSpread`]]
        this[`${prefix}oxShadowColor`] = [this[`${prefix}oxShadowColor`]]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this[`${prefix}oxShadowH`]))
      let boxShadowV = JSON.parse(JSON.stringify(this[`${prefix}oxShadowV`]))
      let boxShadowBlur = JSON.parse(JSON.stringify(this[`${prefix}oxShadowBlur`]))
      let boxShadowSpread = JSON.parse(JSON.stringify(this[`${prefix}oxShadowSpread`]))
      let boxShadowColor = JSON.parse(JSON.stringify(this[`${prefix}oxShadowColor`]))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this[`${prefix}oxShadowH`] = boxShadowH
      this[`${prefix}oxShadowV`] = boxShadowV
      this[`${prefix}oxShadowBlur`] = boxShadowBlur
      this[`${prefix}oxShadowSpread`] = boxShadowSpread
      this[`${prefix}oxShadowColor`] = boxShadowColor
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    explainDialogClick() {
      this.explainDialog = true
      this.explainTitle = "尺寸自动"
      this.explainTips = "开启后，下拉列表项的宽度、高度会自适应至合适高度，不能手动调整"
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    directionMode: {
      get() {
        return this.options.mode
      },
      set(val) {
        this.$changeOptionsEV(val, "mode", false)
      }
    },
    menuTrigger: {
      get() {
        return this.options.menuTrigger
      },
      set(val) {
        this.$changeOptionsEV(val, "menuTrigger", false)
      }
    },
    collapse: {
      get() {
        return this.options.collapse
      },
      set(val) {
        this.$changeOptionsEV(val, "collapse", false)
      }
    },
    opacity: {
      get() {
        // return this.options.opacity || 100
        return this.checkAndSetPrimaryVal(this.options, "opacity", "opacity", 100)
      },
      set(newVal) {
        newVal !== this.opacity && this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    indent: {
      get() {
        return this.options.indent
      },
      set(newVal) {
        newVal !== this.indent && this.$changeOptionsEV(newVal, "indent", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    iconPosition: {
      get() {
        return this.options.iconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPosition", false)
      }
    },
    iconSrc: {
      get() {
        return this.options.iconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc", false)
      }
    },
    iconType: {
      get() {
        return this.options.iconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType", false)
      }
    },
    iconWidth: {
      get() {
        return this.options.iconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconWidth", false)
      }
    },
    iconMargin: {
      get() {
        return this.options.iconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconMargin", false)
      }
    },
    iconColor: {
      get() {
        return this.options.iconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.options.iconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColorIsThemeColor", false)
      }
    },
    activeArrangement() {
      return this.options.textAlign
    },
    topNavBackground: {
      get() {
        let background = this.options.topNavBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.topNavBackground
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "topNavBackground", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBackground", false)
      }
    },
    topNavBackground1: {
      get() {
        let background = this.options.topNavBackground1
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.topNavBackground1
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "topNavBackground1", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBackground1", false)
      }
    },
    topNavTextLimitCount: {
      get() {
        return this.options.topNavTextLimitCount
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavTextLimitCount", false)
      }
    },
    topNavTextLimit: {
      get() {
        return this.options.topNavTextLimit
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavTextLimit", false)
      }
    },
    activeArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "writingMode", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "fontWeight", false)
      }
    },
    fontColor: {
      get() {
        return this.options.fontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "fontColor", false)
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "letterSpacing", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    lineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lineHeightType", "lineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    textAlign: {
      get() {
        return this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.options.textIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    colorArr: {
      get() {
        let color = this.options.colorArr
        if (color && JSON.stringify(color) !== "{}") {
          return color
        }
        let newColor = {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          data: {
            angle: 0,
            stops: [
              [this.options.color, 0],
              ["rgba(255, 255, 255, 0.8)", 1]
            ]
          }
        }
        this.$changeOptionsEV(newColor, "colorArr", false, false, false, true)
        return newColor
      },
      set(val) {
        this.$changeOptionsEV(val, "colorArr", false)
      }
    },
    activeNameColor: {
      get() {
        return this.options.activeNameColor || "first"
      },
      set(val) {
        this.$changeOptionsEV(val, "activeNameColor", false)
      }
    },
    writingMode: {
      get() {
        return this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(val) {
        this.$changeOptionsEV(val, "bgColor", false)
      }
    },
    bgIsThemeColor: {
      get() {
        return this.options.bgIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "bgIsThemeColor", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "borderColor", false)
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "borderWidth", false)
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "borderStyle", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "borderIsThemeColor", false)
      }
    },

    topNavBorderColor: {
      get() {
        return this.options.topNavBorderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBorderColor", false)
      }
    },
    topNavBorderWidth: {
      get() {
        return this.options.topNavBorderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBorderWidth", false)
      }
    },
    topNavBorderStyle: {
      get() {
        return this.options.topNavBorderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBorderStyle", false)
      }
    },
    topNavBorderIsThemeColor: {
      get() {
        return this.options.topNavBorderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBorderIsThemeColor", false)
      }
    },
    topNavBorderTypeFlag: {
      get() {
        let defaultType = 1
        // if (!this.options.hasOwnProperty("topNavBorderTypeFlag")) {
        //   if (
        //     ((this.topNavBorderTopLeftRadius === this.topNavBorderTopRightRadius) ===
        //       this.topNavBorderBottomLeftRadius) ===
        //     this.topNavBorderBottomRightRadius
        //   ) {
        //     defaultType = 2
        //   }
        // }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.topNavBorderTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderTypeFlag", false)
      }
    },
    topNavBorderRadius: {
      get() {
        return Number(this.options.topNavBorderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          [
            "topNavBorderTopLeftRadius",
            "topNavBorderTopRightRadius",
            "topNavBorderBottomRightRadius",
            "topNavBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    topNavBorderTopLeftRadius: {
      get() {
        return Number(this.options.topNavBorderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderTopLeftRadius", false)
      }
    },
    topNavBorderTopRightRadius: {
      get() {
        return Number(this.options.topNavBorderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderTopRightRadius", false)
      }
    },
    topNavBorderBottomRightRadius: {
      get() {
        return Number(this.options.topNavBorderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderBottomRightRadius", false)
      }
    },
    topNavBorderBottomLeftRadius: {
      get() {
        return Number(this.options.topNavBorderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderBottomLeftRadius", false)
      }
    },
    topNavBoxShadowColor: {
      get() {
        return this.options.topNavBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowColor", false)
      }
    },
    topNavBoxShadowH: {
      get() {
        return this.options.topNavBoxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowH", false)
      }
    },
    topNavBoxShadowV: {
      get() {
        return this.options.topNavBoxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowV", false)
      }
    },
    topNavBoxShadowBlur: {
      get() {
        return this.options.topNavBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowBlur", false)
      }
    },
    topNavBoxShadowSpread: {
      get() {
        return this.options.topNavBoxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowSpread", false)
      }
    },
    // 边距
    topNavPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("topNavPaddingTypeFlag")) {
          if (
            ((this.topNavPaddingTop === this.topNavPaddingRight) === this.topNavPaddingLeft) ===
            this.topNavPaddingBottom
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "topNavPaddingTypeFlag", "topNavPaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingTypeFlag", false)
      }
    },
    topNavPadding: {
      get() {
        // return this.options.padding || 0
        return this.checkAndSetPrimaryVal(this.options, "topNavPadding", "topNavPadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPadding", false)
      }
    },
    topNavPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topNavPaddingTop", "topNavPaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingTop", false)
      }
    },
    topNavPaddingRight: {
      get() {
        // return this.options.paddingRight || 0
        return this.checkAndSetPrimaryVal(this.options, "topNavPaddingRight", "topNavPaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingRight", false)
      }
    },
    topNavPaddingLeft: {
      get() {
        // return this.options.paddingLeft || 0
        return this.checkAndSetPrimaryVal(this.options, "topNavPaddingLeft", "topNavPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingLeft", false)
      }
    },
    topNavPaddingBottom: {
      get() {
        // return this.options.paddingBottom || 0
        return this.checkAndSetPrimaryVal(this.options, "topNavPaddingBottom", "topNavPaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingBottom", false)
      }
    },
    liIsSameSize: {
      get() {
        return this.options.liIsSameSize
      },
      set(val) {
        this.$changeOptionsEV(val, "liIsSameSize", false)
      }
    },
    clearLastBorder: {
      get() {
        return this.options.clearLastBorder
      },
      set(val) {
        this.$changeOptionsEV(val, "clearLastBorder", false)
      }
    },
    clearActiveLastBorder: {
      get() {
        return this.options.clearActiveLastBorder
      },
      set(val) {
        this.$changeOptionsEV(val, "clearActiveLastBorder", false)
      }
    },
    clearHoverLastBorder: {
      get() {
        return this.options.clearHoverLastBorder
      },
      set(val) {
        this.$changeOptionsEV(val, "clearHoverLastBorder", false)
      }
    },
    clearLiLastBorder: {
      get() {
        return this.options.clearLiLastBorder
      },
      set(val) {
        this.$changeOptionsEV(val, "clearLiLastBorder", false)
      }
    },
    clearLiHoverLastBorder: {
      get() {
        return this.options.clearLiHoverLastBorder
      },
      set(val) {
        this.$changeOptionsEV(val, "clearLiHoverLastBorder", false)
      }
    },
    liWidth: {
      get() {
        return this.options.liWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "liWidth", false)
      }
    },
    liHeight: {
      get() {
        return this.options.liHeight
      },
      set(val) {
        this.$changeOptionsEV(val, "liHeight", false)
      }
    },
    showPlaceHolderText: {
      get() {
        return this.options.showPlaceHolderText
      },
      set(val) {
        this.$changeOptionsEV(val, "showPlaceHolderText", false)
      }
    },
    placeholderText: {
      get() {
        return this.options.placeholderText
      },
      set(val) {
        this.$changeOptionsEV(val, "placeholderText", false)
      }
    },
    selectFontFamily: {
      get() {
        return this.options.selectFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontFamily", false)
      }
    },
    selectFontSize: {
      get() {
        return this.options.selectFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontSize", false)
      }
    },
    selectFontWeight: {
      get() {
        return this.options.selectFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontWeight", false)
      }
    },
    selectFontColor: {
      get() {
        return this.options.selectFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontColor", false)
      }
    },
    selectBgColor: {
      get() {
        return this.options.selectBgColor
      },
      set(val) {
        this.$changeOptionsEV(val, "selectBgColor", false)
      }
    },
    selectBgIsThemeColor: {
      get() {
        return this.options.selectBgIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "selectBgIsThemeColor", false)
      }
    },
    selectBoxShadowColor: {
      get() {
        return this.options.selectBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectBoxShadowColor", false)
      }
    },
    selectBoxShadowH: {
      get() {
        return this.options.selectBoxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectBoxShadowH", false)
      }
    },
    selectBoxShadowV: {
      get() {
        return this.options.selectBoxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectBoxShadowV", false)
      }
    },
    selectBoxShadowBlur: {
      get() {
        return this.options.selectBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectBoxShadowBlur", false)
      }
    },
    selectBoxShadowSpread: {
      get() {
        return this.options.selectBoxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectBoxShadowSpread", false)
      }
    },
    liBorderColor: {
      get() {
        return this.options.liBorderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderColor", false)
      }
    },
    liBorderWidth: {
      get() {
        return this.options.liBorderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderWidth", false)
      }
    },
    liBorderStyle: {
      get() {
        return this.options.liBorderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderStyle", false)
      }
    },
    liBorderIsThemeColor: {
      get() {
        return this.options.liBorderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderIsThemeColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderTopLeftRadius: {
      get() {
        return Number(this.options.borderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return Number(this.options.borderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return Number(this.options.borderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    liActiveArrangement() {
      return this.options.liTextAlign
    },
    liActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "liWritingMode", false)
      }
    },
    liLetterSpacing: {
      get() {
        return this.options.liLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "liLetterSpacing", false)
      }
    },
    liLineHeight: {
      get() {
        return this.options.liLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liLineHeight", false)
      }
    },
    liLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liLineHeightType", "liLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liLineHeightType", false)
      }
    },
    liIsThemeColor: {
      get() {
        return this.options.liIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIsThemeColor", false)
      }
    },
    liFontStyle: {
      get() {
        return this.options.liFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liFontStyle", false)
      }
    },
    liTextAlign: {
      get() {
        return this.options.liTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextAlign", false)
      }
    },
    liTextIsThemeColor: {
      get() {
        return this.options.liTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextIsThemeColor", false)
      }
    },
    liWritingMode: {
      get() {
        return this.options.liWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liWritingMode", false)
      }
    },
    liTextDecoration: {
      get() {
        return this.options.liTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextDecoration", false)
      }
    },
    liFontFamily: {
      get() {
        return this.options.liFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontFamily", false)
      }
    },
    liFontSize: {
      get() {
        return this.options.liFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontSize", false)
      }
    },
    liFontWeight: {
      get() {
        return this.options.liFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontWeight", false)
      }
    },
    liFontColor: {
      get() {
        return this.options.liFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontColor", false)
      }
    },
    liFontColorArr: {
      get() {
        let color = this.options.liFontColorArr
        if (color && JSON.stringify(color) !== "{}") {
          return color
        }
        let newColor = {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          data: {
            angle: 0,
            stops: [
              [this.options.color, 0],
              ["rgba(255, 255, 255, 0.8)", 1]
            ]
          }
        }
        this.$changeOptionsEV(newColor, "liFontColorArr", false, false, false, true)
        return newColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontColorArr", false)
      }
    },
    liFontActiveNameColor: {
      get() {
        return this.options.liFontActiveNameColor || "first"
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontActiveNameColor", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    widthAuto: {
      get() {
        return this.options.widthAuto
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "widthAuto", false)
      }
    },
    navWidth: {
      get() {
        return this.options.navWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "navWidth", false)
      }
    },
    activeBgColor: {
      get() {
        let background = this.options.activeBgColor
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.activeBgColor
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.activeBgColor.color ? this.options.activeBgColor.color : this.options.activeBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "activeBgColor", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColor", false)
      }
    },
    activeBgIsThemeColor: {
      get() {
        return this.options.activeBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgIsThemeColor", false)
      }
    },
    activeBorderWidth: {
      get() {
        return this.options.activeBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderWidth", false)
      }
    },
    activeBorderColor: {
      get() {
        return this.options.activeBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderColor", false)
      }
    },
    activeBorderStyle: {
      get() {
        return this.options.activeBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderStyle", false)
      }
    },
    activeBorderIsThemeColor: {
      get() {
        return this.options.activeBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderIsThemeColor", false)
      }
    },
    activeActiveArrangement() {
      return this.options.activeTextAlign
    },
    activeActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "liWritingMode", false)
      }
    },
    activeLetterSpacing: {
      get() {
        return this.options.activeLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "activeLetterSpacing", false)
      }
    },
    activeLineHeight: {
      get() {
        return this.options.activeLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLineHeight", false)
      }
    },
    activeLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeLineHeightType", "activeLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLineHeightType", false)
      }
    },
    hoverLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hoverLineHeightType", "hoverLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLineHeightType", false)
      }
    },
    activeFontStyle: {
      get() {
        return this.options.activeFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontStyle", false)
      }
    },
    activeTextAlign: {
      get() {
        return this.options.activeTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextAlign", false)
      }
    },
    activeTextIsThemeColor: {
      get() {
        return this.options.activeTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextIsThemeColor", false)
      }
    },
    activeFontColorArr: {
      get() {
        let color = this.options.activeFontColorArr
        if (color && JSON.stringify(color) !== "{}") {
          return color
        }
        let newColor = {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          data: {
            angle: 0,
            stops: [
              [this.options.color, 0],
              ["rgba(255, 255, 255, 0.8)", 1]
            ]
          }
        }
        this.$changeOptionsEV(newColor, "activeFontColorArr", false, false, false, true)
        return newColor
      },
      set(val) {
        this.$changeOptionsEV(val, "activeFontColorArr", false)
      }
    },
    activeActiveNameColor: {
      get() {
        return this.options.activeActiveNameColor || "first"
      },
      set(val) {
        this.$changeOptionsEV(val, "activeActiveNameColor", false)
      }
    },
    activeWritingMode: {
      get() {
        return this.options.activeWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeWritingMode", false)
      }
    },
    activeTextDecoration: {
      get() {
        return this.options.activeTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextDecoration", false)
      }
    },
    activeFontFamily: {
      get() {
        return this.options.activeFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontFamily", false)
      }
    },
    activeFontSize: {
      get() {
        return this.options.activeFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontSize", false)
      }
    },
    activeFontWeight: {
      get() {
        return this.options.activeFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontWeight", false)
      }
    },
    activeFontColor: {
      get() {
        return this.options.activeFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontColor", false)
      }
    },
    hoverBgColor: {
      get() {
        let background = this.options.hoverBgColor
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.hoverBgColor
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.hoverBgColor.color ? this.options.hoverBgColor.color : this.options.hoverBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "hoverBgColor", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColor", false)
      }
    },
    hoverBgIsThemeColor: {
      get() {
        return this.options.hoverBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgIsThemeColor", false)
      }
    },
    hoverBorderWidth: {
      get() {
        return this.options.hoverBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderWidth", false)
      }
    },
    hoverBorderColor: {
      get() {
        return this.options.hoverBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderColor", false)
      }
    },
    hoverBorderStyle: {
      get() {
        return this.options.hoverBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderStyle", false)
      }
    },
    hoverBorderIsThemeColor: {
      get() {
        return this.options.hoverBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderIsThemeColor", false)
      }
    },
    hoverActiveArrangement() {
      return this.options.hoverTextAlign
    },
    hoverActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "hoverWritingMode", false)
      }
    },
    hoverLetterSpacing: {
      get() {
        return this.options.hoverLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "hoverLetterSpacing", false)
      }
    },
    hoverLineHeight: {
      get() {
        return this.options.hoverLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLineHeight", false)
      }
    },
    hoverFontStyle: {
      get() {
        return this.options.hoverFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontStyle", false)
      }
    },
    hoverTextAlign: {
      get() {
        return this.options.hoverTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextAlign", false)
      }
    },
    hoverTextIsThemeColor: {
      get() {
        return this.options.hoverTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextIsThemeColor", false)
      }
    },
    hoverFontColorArr: {
      get() {
        let color = this.options.hoverFontColorArr
        if (color && JSON.stringify(color) !== "{}") {
          return color
        }
        let newColor = {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          data: {
            angle: 0,
            stops: [
              [this.options.color, 0],
              ["rgba(255, 255, 255, 0.8)", 1]
            ]
          }
        }
        this.$changeOptionsEV(newColor, "hoverFontColorArr", false, false, false, true)
        return newColor
      },
      set(val) {
        this.$changeOptionsEV(val, "hoverFontColorArr", false)
      }
    },
    hoverActiveNameColor: {
      get() {
        return this.options.hoverActiveNameColor || "first"
      },
      set(val) {
        this.$changeOptionsEV(val, "hoverActiveNameColor", false)
      }
    },
    hoverWritingMode: {
      get() {
        return this.options.hoverWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverWritingMode", false)
      }
    },
    hoverTextDecoration: {
      get() {
        return this.options.hoverTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextDecoration", false)
      }
    },
    hoverFontFamily: {
      get() {
        return this.options.hoverFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontFamily", false)
      }
    },
    hoverFontSize: {
      get() {
        return this.options.hoverFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontSize", false)
      }
    },
    hoverFontWeight: {
      get() {
        return this.options.hoverFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontWeight", false)
      }
    },
    hoverFontColor: {
      get() {
        return this.options.hoverFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontColor", false)
      }
    },
    hoverIsSameActive: {
      get() {
        return this.options.hoverIsSameActive
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverIsSameActive", false)
      }
    },
    liHoverBgColor: {
      get() {
        let background = this.options.liHoverBgColor
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.liHoverBgColor
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.liHoverBgIsThemeColor,
            color: this.options.liHoverBgColor.color ? this.options.liHoverBgColor.color : this.options.liHoverBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "liHoverBgColor", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBgColor", false)
      }
    },
    liHoverBgIsThemeColor: {
      get() {
        return this.options.liHoverBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBgIsThemeColor", false)
      }
    },
    liHoverBorderWidth: {
      get() {
        return this.options.liHoverBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderWidth", false)
      }
    },
    liHoverBorderColor: {
      get() {
        return this.options.liHoverBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderColor", false)
      }
    },
    liHoverBorderStyle: {
      get() {
        return this.options.liHoverBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderStyle", false)
      }
    },
    liHoverBorderIsThemeColor: {
      get() {
        return this.options.liHoverBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderIsThemeColor", false)
      }
    },
    liHoverActiveArrangement() {
      return this.options.liHoverTextAlign
    },
    liHoverActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "liHoverWritingMode", false)
      }
    },
    liHoverLetterSpacing: {
      get() {
        return this.options.liHoverLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "liHoverLetterSpacing", false)
      }
    },
    liHoverLineHeight: {
      get() {
        return this.options.liHoverLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverLineHeight", false)
      }
    },
    liHoverLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liHoverLineHeightType", "liHoverLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverLineHeightType", false)
      }
    },
    liHoverFontStyle: {
      get() {
        return this.options.liHoverFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontStyle", false)
      }
    },
    liHoverTextAlign: {
      get() {
        return this.options.liHoverTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverTextAlign", false)
      }
    },
    liHoverTextIsThemeColor: {
      get() {
        return this.options.liHoverTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverTextIsThemeColor", false)
      }
    },
    liHoverFontColorArr: {
      get() {
        let color = this.options.liHoverFontColorArr
        if (color && JSON.stringify(color) !== "{}") {
          return color
        }
        let newColor = {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          data: {
            angle: 0,
            stops: [
              [this.options.color, 0],
              ["rgba(255, 255, 255, 0.8)", 1]
            ]
          }
        }
        this.$changeOptionsEV(newColor, "liHoverFontColorArr", false, false, false, true)
        return newColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liHoverFontColorArr", false)
      }
    },
    liHoverActiveNameColor: {
      get() {
        return this.options.liHoverActiveNameColor || "first"
      },
      set(val) {
        this.$changeOptionsEV(val, "liHoverActiveNameColor", false)
      }
    },
    liHoverWritingMode: {
      get() {
        return this.options.liHoverWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverWritingMode", false)
      }
    },
    liHoverTextDecoration: {
      get() {
        return this.options.liHoverTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverTextDecoration", false)
      }
    },
    liHoverFontFamily: {
      get() {
        return this.options.liHoverFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontFamily", false)
      }
    },
    liHoverFontSize: {
      get() {
        return this.options.liHoverFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontSize", false)
      }
    },
    liHoverFontWeight: {
      get() {
        return this.options.liHoverFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontWeight", false)
      }
    },
    liHoverFontColor: {
      get() {
        return this.options.liHoverFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontColor", false)
      }
    },
    liHoverIsSameActive: {
      get() {
        return this.options.liHoverIsSameActive || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverIsSameActive", false)
      }
    },
    liActiveBgColor: {
      get() {
        let background = this.options.liActiveBgColor
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.liActiveBgColor
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.liActiveBgIsThemeColor,
            color: this.options.liActiveBgColor.color
              ? this.options.liActiveBgColor.color
              : this.options.liActiveBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "liActiveBgColor", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBgColor", false)
      }
    },
    liActiveBgIsThemeColor: {
      get() {
        return this.options.liActiveBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBgIsThemeColor", false)
      }
    },
    liActiveBorderWidth: {
      get() {
        return this.options.liActiveBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderWidth", false)
      }
    },
    liActiveBorderColor: {
      get() {
        return this.options.liActiveBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderColor", false)
      }
    },
    liActiveBorderStyle: {
      get() {
        return this.options.liActiveBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderStyle", false)
      }
    },
    liActiveBorderIsThemeColor: {
      get() {
        return this.options.liActiveBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderIsThemeColor", false)
      }
    },
    liActiveActiveArrangement() {
      return this.options.liActiveTextAlign
    },
    liActiveActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "liActiveWritingMode", false)
      }
    },
    liActiveLetterSpacing: {
      get() {
        return this.options.liActiveLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "liActiveLetterSpacing", false)
      }
    },
    liActiveLineHeight: {
      get() {
        return this.options.liActiveLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveLineHeight", false)
      }
    },
    liActiveLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveLineHeightType", "liActiveLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveLineHeightType", false)
      }
    },
    liActiveFontStyle: {
      get() {
        return this.options.liActiveFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontStyle", false)
      }
    },
    liActiveTextAlign: {
      get() {
        return this.options.liActiveTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveTextAlign", false)
      }
    },
    liActiveTextIsThemeColor: {
      get() {
        return this.options.liActiveTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveTextIsThemeColor", false)
      }
    },
    liActiveFontColorArr: {
      get() {
        let color = this.options.liActiveFontColorArr
        if (color && JSON.stringify(color) !== "{}") {
          return color
        }
        let newColor = {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          data: {
            angle: 0,
            stops: [
              [this.options.color, 0],
              ["rgba(255, 255, 255, 0.8)", 1]
            ]
          }
        }
        this.$changeOptionsEV(newColor, "liActiveFontColorArr", false, false, false, true)
        return newColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liActiveFontColorArr", false)
      }
    },
    liActiveActiveNameColor: {
      get() {
        return this.options.liActiveActiveNameColor || "first"
      },
      set(val) {
        this.$changeOptionsEV(val, "liActiveActiveNameColor", false)
      }
    },
    liActiveWritingMode: {
      get() {
        return this.options.liActiveWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveWritingMode", false)
      }
    },
    liActiveTextDecoration: {
      get() {
        return this.options.liActiveTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveTextDecoration", false)
      }
    },
    liActiveFontFamily: {
      get() {
        return this.options.liActiveFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontFamily", false)
      }
    },
    liActiveFontSize: {
      get() {
        return this.options.liActiveFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontSize", false)
      }
    },
    liActiveFontWeight: {
      get() {
        return this.options.liActiveFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontWeight", false)
      }
    },
    liActiveFontColor: {
      get() {
        return this.options.liActiveFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontColor", false)
      }
    },
    liActiveIsSameActive: {
      get() {
        return this.options.liActiveIsSameActive
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIsSameActive", false)
      }
    },
    ulBgIsThemeColor: {
      get() {
        return this.options.ulBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulBgIsThemeColor", false)
      }
    },
    ulBgColor: {
      get() {
        return this.options.ulBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulBgColor", false)
      }
    },
    topNavMarginBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topNavMarginBottom", "topNavMarginBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavMarginBottom", false)
      }
    },
    liMarginBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liMarginBottom", "liMarginBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liMarginBottom", false)
      }
    },
    liBgIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liBgIsThemeColor", "liBgIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBgIsThemeColor", false)
      }
    },
    liBgColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liBgColor", "liBgColor", "rgba(0,0,0,0)")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBgColor", false)
      }
    },
    topNavTextLimitCount1: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topNavTextLimitCount1", "topNavTextLimitCount1", 4)
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavTextLimitCount1", false)
      }
    },
    topNavTextLimit1: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topNavTextLimit1", "topNavTextLimit1", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavTextLimit1", false)
      }
    },
    topNavBorderTypeFlag1: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topNavBorderTypeFlag1", "topNavBorderTypeFlag1", 2)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderTypeFlag1", false)
      }
    },
    topNavBorderRadius1: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topNavBorderTopLeftRadius1", "topNavBorderTopLeftRadius1", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          [
            "topNavBorderTopLeftRadius1",
            "topNavBorderTopRightRadius1",
            "topNavBorderBottomRightRadius1",
            "topNavBorderBottomLeftRadius1"
          ],
          false
        )
      }
    },
    topNavBorderTopLeftRadius1: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topNavBorderTopLeftRadius1", "topNavBorderTopLeftRadius1", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderTopLeftRadius1", false)
      }
    },
    topNavBorderTopRightRadius1: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topNavBorderTopRightRadius1", "topNavBorderTopRightRadius1", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderTopRightRadius1", false)
      }
    },
    topNavBorderBottomRightRadius1: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "topNavBorderBottomRightRadius1",
          "topNavBorderBottomRightRadius1",
          0
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderBottomRightRadius1", false)
      }
    },
    topNavBorderBottomLeftRadius1: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "topNavBorderBottomLeftRadius1",
          "topNavBorderBottomLeftRadius1",
          0
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderBottomLeftRadius1", false)
      }
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    }
  }
})
</script>

<style scoped>
.flex-box {
  flex: 1;
  max-width: 68%;
}
</style>
